import React from 'react'
import ConfidenceTick from './ConfidenceTick'
import styles from './styles/rating-with-confidence.module.scss'
import cx from 'classnames'
import { ClassNamesProps } from 'types/utilities'
import { useTranslation } from 'react-i18next'

type ClassKeys = 'rating' | 'confidence'

interface Props extends ClassNamesProps<ClassKeys> {
  rating?: string | number
  confidence?: number
}

const RatingWithConfidenceTick = ({ rating, confidence, classNames }: Props) => {
  const { t } = useTranslation('strCommonUI')

  return (
    <>
      <span
        className={cx(styles.rating, classNames?.rating)}
        aria-label={!rating ? t('ariaLabel.noRating') : undefined}
      >
        {rating || '-'}
      </span>
      <ConfidenceTick
        score={confidence}
        className={cx(styles.confidence, classNames?.confidence)}
      />
    </>
  )
}

export default RatingWithConfidenceTick
